import * as React from 'react';
import { SVGProps } from 'react';
import { Box, BoxProps, styled } from '@mui/material';

const IconBox = styled(Box)<BoxProps>(({ theme }) => ({
  width: '32px',
  height: '32px',
  borderRadius: '4px',
  padding: '4px',
  boxSizing: 'border-box',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  backgroundColor: theme.palette.secondary.main,
}));

const UnitsSQIcon = (props: SVGProps<SVGSVGElement>) => {
  return (
    <IconBox>
      <svg
        width="16"
        height="10"
        viewBox="0 0 16 10"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        <path
          d="M14.6667 4.33398H14V2.33398C14 1.80355 13.7893 1.29484 13.4142 0.919771C13.0391 0.544698 12.5304 0.333984 12 0.333984C11.4696 0.333984 10.9609 0.544698 10.5858 0.919771C10.2107 1.29484 10 1.80355 10 2.33398V4.33398H6V2.33398C6 1.80355 5.78928 1.29484 5.41421 0.919771C5.03914 0.544698 4.53043 0.333984 4 0.333984C3.46956 0.333984 2.96086 0.544698 2.58578 0.919771C2.21071 1.29484 2 1.80355 2 2.33398V4.33398H1.33333C1.15652 4.33398 0.98695 4.40422 0.861926 4.52925C0.736902 4.65427 0.666664 4.82384 0.666664 5.00065C0.666664 5.17746 0.736902 5.34703 0.861926 5.47206C0.98695 5.59708 1.15652 5.66732 1.33333 5.66732H2V7.66732C2 8.19775 2.21071 8.70646 2.58578 9.08153C2.96086 9.4566 3.46956 9.66732 4 9.66732C4.53043 9.66732 5.03914 9.4566 5.41421 9.08153C5.78928 8.70646 6 8.19775 6 7.66732V5.66732H10V7.66732C10 8.19775 10.2107 8.70646 10.5858 9.08153C10.9609 9.4566 11.4696 9.66732 12 9.66732C12.5304 9.66732 13.0391 9.4566 13.4142 9.08153C13.7893 8.70646 14 8.19775 14 7.66732V5.66732H14.6667C14.8435 5.66732 15.013 5.59708 15.1381 5.47206C15.2631 5.34703 15.3333 5.17746 15.3333 5.00065C15.3333 4.82384 15.2631 4.65427 15.1381 4.52925C15.013 4.40422 14.8435 4.33398 14.6667 4.33398ZM4.66666 7.66732C4.66666 7.84413 4.59643 8.0137 4.4714 8.13872C4.34638 8.26375 4.17681 8.33398 4 8.33398C3.82319 8.33398 3.65362 8.26375 3.52859 8.13872C3.40357 8.0137 3.33333 7.84413 3.33333 7.66732V2.33398C3.33333 2.15717 3.40357 1.9876 3.52859 1.86258C3.65362 1.73756 3.82319 1.66732 4 1.66732C4.17681 1.66732 4.34638 1.73756 4.4714 1.86258C4.59643 1.9876 4.66666 2.15717 4.66666 2.33398V7.66732ZM12.6667 7.66732C12.6667 7.84413 12.5964 8.0137 12.4714 8.13872C12.3464 8.26375 12.1768 8.33398 12 8.33398C11.8232 8.33398 11.6536 8.26375 11.5286 8.13872C11.4036 8.0137 11.3333 7.84413 11.3333 7.66732V2.33398C11.3333 2.15717 11.4036 1.9876 11.5286 1.86258C11.6536 1.73756 11.8232 1.66732 12 1.66732C12.1768 1.66732 12.3464 1.73756 12.4714 1.86258C12.5964 1.9876 12.6667 2.15717 12.6667 2.33398V7.66732Z"
          fill="#4A4F55"
        />
      </svg>
    </IconBox>
  );
};

export default UnitsSQIcon;
